<template>
  <InputText
    v-model="localValue"
    :placeholder="placeholder"
    :class="inputClass"
    :disabled="disabled"
    @input="onInput"
    @keydown.enter="flushNow"
  />
</template>

<script>
import InputText from "primevue/inputtext";

export default {
  name: "DebouncedFilterInput",
  components: { InputText },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: { type: [String, Number], default: null },
    callback: { type: Function, default: null },
    delay: { type: Number, default: 500 },
    placeholder: { type: String, default: "" },
    inputClass: { type: String, default: "p-column-filter" },
    disabled: { type: Boolean, default: false },
    minChars: { type: Number, default: 0 },
  },
  data() {
    return {
      localValue: this.value,
      timer: null,
    };
  },
  watch: {
    value(newVal) {
      if (newVal !== this.localValue) {
        this.localValue = newVal;
      }
    },
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  },
  methods: {
    onInput(rawOrEvent) {
      const next = typeof rawOrEvent === "object" && rawOrEvent !== null
        ? rawOrEvent.target.value
        : rawOrEvent;

      this.localValue = next;
      this.scheduleEmit(next);
    },
    scheduleEmit(value) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.emitChange(value);
      }, this.delay);
    },
    flushNow() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.emitChange(this.localValue);
    },
    emitChange(value) {
      const isEmpty = value === null || value === undefined || value === "";
      if (!isEmpty && this.minChars > 0 && String(value).length < this.minChars) {
        return;
      }
      this.$emit("input", value);
      if (typeof this.callback === "function") {
        this.callback();
      }
    },
  },
};
</script>
